import React from 'react';
import PropTypes from 'prop-types';
import { Pagination } from 'semantic-ui-react';
import { colorsModeUI } from '../modeUI';
import './index.css';

/**
 * Ui Pagination
 * Add mode DARK or LIGHT to the semantic component Pagination
 * Props (parameters)
 * @param string id
 * @param number defaultActivePage
 * @param number totalPages
 * @param func onPageChange
 * @param string mode
 */
export default class UiPagination extends React.PureComponent {
  render() {
    const { id, defaultActivePage, totalPages, onPageChange, mode } =
      this.props;
    const style = {};
    if (mode !== null) {
      const modeColors = colorsModeUI(mode);
      style.backgroundColor = modeColors.PAGINATION_BACKGROUND_COLOR;
    }
    let pagination = (
      <Pagination
        defaultActivePage={defaultActivePage}
        totalPages={totalPages}
        style={style}
        className={`${mode ? 'ui-pagination' : ''}`}
      />
    );
    pagination = (
      <pagination.type
        {...pagination.props}
        {...(id ? { id } : {})}
        {...(onPageChange ? { onPageChange } : {})}
      />
    );
    return pagination;
  }
}

UiPagination.propTypes = {
  id: PropTypes.string,
  defaultActivePage: PropTypes.number,
  totalPages: PropTypes.number,
  onPageChange: PropTypes.func,
  mode: PropTypes.string,
};

UiPagination.defaultProps = {
  id: null,
  defaultActivePage: 1,
  totalPages: 1,
  onPageChange: null,
  mode: null,
};
